import { useRestPostQuery } from 'utils/hooks/api';
import { TriggeredMessagesRequest } from '../types';
import { useMemo } from 'react';
import { CampaignState } from 'constants/campaignStates';
import { CampaignTypes } from 'modules/messagingInsights/types';
import {
  HIGH_LEVEL_LABELS_TO_VALUES,
  METRIC_LABELS_TO_VALUES,
} from 'constants/metricLabelsToValues';
import { MessageMedium } from 'constants/messageMediums';

const ANALYTICS_METRICS_AGGREGATE_URL = '/analytics/metrics/aggregate';

interface GetInsigthsMetricsRequest {
  startTime: string;
  endTime: string;
  campaignFilters: {
    mediums: string[];
    states: string[];
    types: string[];
  };
  metrics: {
    overallMetrics: { enumName: string }[];
    mediumMetrics: { name: string }[];
  };
}

interface GetInsigthsMetricsResponse {
  mediumMetrics: { ['Unique Email Sends']?: { value: number } };
  overallMetrics: { ['Total Sent']?: { value: number } };
}
export const useGetInsightsMetrics = (
  requestParams: TriggeredMessagesRequest,
  { enabled }: { enabled: boolean },
) => {
  /** Insights data should display info about unique email sends and
   * total message sends (all message mediums) for the selected date range */
  const reqBody = useMemo(
    () => ({
      startTime: requestParams.startDate,
      endTime: requestParams.endDate,
      campaignFilters: {
        mediums: [
          MessageMedium.Email,
          MessageMedium.SMS,
          MessageMedium.Push,
          MessageMedium.InApp,
          MessageMedium.WebPush,
        ],
        states: [CampaignState.Running, CampaignState.Finished],
        types: [CampaignTypes.TRIGGERED, CampaignTypes.FROM_WORKFLOW],
      },
      metrics: {
        overallMetrics: [
          {
            enumName: HIGH_LEVEL_LABELS_TO_VALUES['Total Sent'],
          },
        ],
        mediumMetrics: [
          {
            name: METRIC_LABELS_TO_VALUES(false)['Unique Email Sends'],
          },
        ],
      },
    }),
    [requestParams.startDate, requestParams.endDate],
  );

  const { data, refetch, isLoading, isError, isSuccess, error } = useRestPostQuery<
    GetInsigthsMetricsResponse,
    GetInsigthsMetricsRequest
  >(ANALYTICS_METRICS_AGGREGATE_URL, reqBody, { enabled });

  return { data, refetch, isLoading, isError, isSuccess, error };
};
